export default {
    RoomName: {
        'Logement': 'housing',
        'Cuisine': 'kitchen',
        'Salle de bain': 'bathroom',
        'Chambre': 'bedroom',
        'Pièce à vivre': 'living',
    },
    ImplementationToText: {
        1: 'Facile',
        2: 'Moyenne',
        3: 'Difficile',
    },
    MetterKind: {
        linky: 'LINKY',
    },
    MailAdresses: {
        commande: 'commande@plum.fr',
        bonjour: 'bonjour@plum.fr',
    },
    RecaptchaKey: {
        'local.unergie.com': '6LdmpCMTAAAAAOwkjg4nAoPEu4pxEyA6XaNAomjN',
        'int.unergie.com': '6LdmpCMTAAAAAOwkjg4nAoPEu4pxEyA6XaNAomjN',
        'preprod.plum-energie.fr': '6LdmpCMTAAAAAOwkjg4nAoPEu4pxEyA6XaNAomjN',
        'plum-energie.fr': '6LcTpiMTAAAAAOU1KsMWBgc-F3skMEIMqXOOBBDE',
        'espace-client.int.plum.fr': '6LdmpCMTAAAAAOwkjg4nAoPEu4pxEyA6XaNAomjN',
        'espace-client.preprod.plum.fr': '6LdmpCMTAAAAAOwkjg4nAoPEu4pxEyA6XaNAomjN',
        'espace-client.plum.fr': '6LcTpiMTAAAAAOU1KsMWBgc-F3skMEIMqXOOBBDE',
    },
    landingPageLink: {
        'local.unergie.com': 'http://local.plum.fr:3005',
        'int.unergie.com': 'https://int.plum.fr',
        'preprod.plum-energie.fr': 'https://preprod.plum.fr',
        'plum-energie.fr': 'https://plum.fr',
        'espace-client.int.plum.fr': 'https://int.plum.fr',
        'espace-client.preprod.plum.fr': 'https://preprod.plum.fr',
        'espace-client.plum.fr': 'https://plum.fr',
    },
    ContactTelephone: {
        emergency: {
            link: 'tel:+33972675092',
            label: '09 72 67 50 92',
        },
        anonymous: {
            link: 'tel:+33977558030',
            label: '09 77 55 80 30',
        },
        client: {
            link: 'tel:+33977558030',
            label: '09 77 55 80 30',
            openingHour: 'en semaine, de 9h à 18h',
        },
        data: {
            email: 'données-personnelles@plum.fr',
        },
        smallBusiness: {
            link: 'tel:+33176490179',
            label: '01 76 49 01 79',
            openingHour: 'en semaine, de 9h à 18h',
        },
        media: {
            email: 'rp@plum-energie.com',
            link: 'tel:+33626141490',
            label: '06 26 14 14 90',
        },
        offreCinqVingtCinq: {
            link: 'tel:+33975182046',
            label: '09 75 18 20 46',
        },
        offreFlashTrente: {
            link: 'tel:+33974593484',
            label: '09 74 59 34 84',
        },
        offrePrintemps2018: {
            link: 'tel:+33975182046',
            label: '09 75 18 20 46',
        },
        offreEte2018: {
            link: 'tel:+33977558030',
            label: '09 77 55 80 30',
        },
        offreEte2018Plum: {
            link: 'tel:+33977556768',
            label: '09 77 55 67 68',
            openingHour: 'du lundi au vendredi, de 9h à 18h',
        },
        offreEte2018Selectra: {
            link: 'tel:+33974593484',
            label: '09 74 59 34 84',
            openingHour: 'du lundi au samedi, de 9h à 18h',
        },
        offreRentree2018: {
            link: 'tel:+33975182046',
            label: '09 75 18 20 46',
            openingHour: 'du lundi au vendredi, de 9h à 18h',
        },
        offreAutomne2018: {
            link: 'tel:+33975182046',
            label: '09 75 18 20 46',
            openingHour: 'du lundi au vendredi, de 9h à 18h',
        },
    },
    ContactSubjects: {
        anonymous: [
      { type: 'question', subject: 'L’offre Plüm - vous hésitez encore ?' },
      { type: 'problem', subject: 'Service client - on peut vous aider !' },
      { type: undefined, subject: 'Améliorez Plüm - idée d’amélioration ou bug' },
      { type: 'question', subject: 'Journaliste - on répond aussi à vos questions :)' },
      { type: undefined, subject: 'Job - rejoignez-nous !' },
        ],
        client: [
      { type: 'question', subject: 'J’ai une question sur mes factures' },
      { type: 'question', subject: 'J’ai une question sur l’espace client' },
      { type: 'question', subject: 'J’ai un problème sur l’espace client' },
      { type: undefined, subject: 'J’ai une suggestion' },
      { type: 'problem', subject: 'J’ai trouvé un bug' },
        ],
    },
    ContractStatus: {
        initial: 0,
        demandeTransmise: 1,
        enService: 2,
        enRecouvrement: 3,
        resilie: 4,
        coupe: 5,
        autre: 6,
        refuseParEnedis: 9,
        resiliationDemande: 14,
        coupureDemande: 15,
        enAttenteEcheancier: 80,
        enAttenteReleve: 81,
        duplicat: 84,
        retracte: 90,
        annule: 91,
        enAttente: 92,
    },
    UserStatus: {
        activeNoContract: 1,
        activeWithContracts: 2,
        activeFinishedContracts: 3,
    },
    ContractStatusLabel: {
        0: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: true },
        1: { timelineStep: 2, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: false },
        2: { timelineStep: 4, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        3: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        4: { timelineStep: 0, termsView: 'STATE-CONTRACT-TERMINATED', isWaitingAction: false },
        5: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        6: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        9: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: false },
        10: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: false },
        14: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        15: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
        80: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: false },
        81: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: true },
        82: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: true },
        83: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: true },
        84: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: false },
        90: { timelineStep: 0, termsView: 'STATE-CONTRACT-CANCELED', isWaitingAction: false },
        91: { timelineStep: 0, termsView: 'STATE-CONTRACT-CANCELED', isWaitingAction: false },
        92: { timelineStep: 1, termsView: 'STATE-CONTRACT-INITIAL', isWaitingAction: true },
        unknown: { timelineStep: 0, termsView: 'STATE-CONTRACT-ACTIVE', isWaitingAction: false },
    },
    PaymentStatus: {
        0: 'Programmé', // 'A transmettre'
        10: 'En cours de traitement', // 'En traitement'
        11: 'En cours de traitement', // 'En traitement CB'
        40: 'En cours de traitement', // 'En attente validation'
        50: 'En cours de traitement', // 'Transmis à slimpay'
        51: 'En cours de traitement', // 'En traitement Odoo'
        55: 'Payé', // 'Référencé Odoo'
        70: 'Rejeté', // 'Annulé'
        90: 'Rejeté', // 'En erreur'
        91: 'Rejeté', // 'Non présenté'
        93: 'Rejeté', // 'rTransaction'
        94: 'Rejeté', // 'Traitement rTransac'
        95: 'Rejeté', // 'rTransac dans Odoo'
        96: 'Rejeté', // 'rTransac rejoué'
        98: 'Rejeté', // 'Consommation de l\'avance'
    },
    PaymentModes: {
        CASH: 'Espèce',
        CB: 'Carte bancaire',
        CHECK: 'Chèque',
        ENERGY_CHECK: 'Chèque énergie',
        POT: 'Cagnotte',
        SEPA: 'Prélèvement bancaire',
        ENERGY_CHECK_BURN: 'Chèque énergie',
    },
    CampaignLandingType: {
        VISITE: 100,
        SUBSCRIBE: 110,
    },
    CommonRegex: {
        fullname: /^[a-zA-ZÀ-ÿ][ 'a-zA-ZÀ-ÿ-]*['a-zA-ZÀ-ÿ]$/i,
        phone: {
            'all': /^(0|(00|\+)33)[6-7][0-9]{8}$/,
            'plus33': /^(\+33)[6-7][0-9]{8}$/,
            '0033': /^(0033)[6-7][0-9]{8}$/,
            '06or07': /^(0)[6-7][0-9]{8}$/,
        },
    },
    StaticTariff: {
        plum: {
            base: {
                3: {
                    abo: 5.74,
                    base: 0.1508,
                },
                6: {
                    abo: 8.92,
                    base: 0.1424,
                },
                9: {
                    abo: 10.42,
                    base: 0.1438,
                },
                12: {
                    abo: 11.96,
                    base: 0.1438,
                },
                15: {
                    abo: 13.5,
                    base: 0.1438,
                },
                18: {
                    abo: 15.27,
                    base: 0.1438,
                },
                24: {
                    abo: 18.41,
                    base: 0.1438,
                },
                30: {
                    abo: 21.79,
                    base: 0.1438,
                },
                36: {
                    abo: 24.46,
                    base: 0.1438,
                },
            },
            hphc: {
                6: {
                    abo: 10.06,
                    hp: 0.1545,
                    hc: 0.1209,
                },
                9: {
                    abo: 12.25,
                    hp: 0.1545,
                    hc: 0.1209,
                },
                12: {
                    abo: 14.26,
                    hp: 0.1545,
                    hc: 0.1209,
                },
                15: {
                    abo: 16.12,
                    hp: 0.1545,
                    hc: 0.1209,
                },
                18: {
                    abo: 17.83,
                    hp: 0.1545,
                    hc: 0.1209,
                },
                24: {
                    abo: 21.83,
                    hp: 0.1545,
                    hc: 0.1209,
                },
                30: {
                    abo: 23.53,
                    hp: 0.1545,
                    hc: 0.1209,
                },
                36: {
                    abo: 26.39,
                    hp: 0.1545,
                    hc: 0.1209,
                },
            },
        },
        edf: {
            base: {
                3: {
                    abo: 5.74,
                    base: 0.1555,
                },
                6: {
                    abo: 8.92,
                    base: 0.1467,
                },
                9: {
                    abo: 10.42,
                    base: 0.1483,
                },
                12: {
                    abo: 11.96,
                    base: 0.1483,
                },
                15: {
                    abo: 13.5,
                    base: 0.1483,
                },
                18: {
                    abo: 15.27,
                    base: 0.1483,
                },
                24: {
                    abo: 18.41,
                    base: 0.1483,
                },
                30: {
                    abo: 21.79,
                    base: 0.1483,
                },
                36: {
                    abo: 24.46,
                    base: 0.1483,
                },
            },
            hphc: {
                6: {
                    abo: 10.06,
                    hp: 0.1593,
                    hc: 0.1244,
                },
                9: {
                    abo: 12.25,
                    hp: 0.1593,
                    hc: 0.1244,
                },
                12: {
                    abo: 14.26,
                    hp: 0.1593,
                    hc: 0.1244,
                },
                15: {
                    abo: 16.12,
                    hp: 0.1593,
                    hc: 0.1244,
                },
                18: {
                    abo: 17.83,
                    hp: 0.1593,
                    hc: 0.1244,
                },
                24: {
                    abo: 21.83,
                    hp: 0.1593,
                    hc: 0.1244,
                },
                30: {
                    abo: 23.53,
                    hp: 0.1593,
                    hc: 0.1244,
                },
                36: {
                    abo: 26.39,
                    hp: 0.1593,
                    hc: 0.1244,
                },
            },
        },
    },
}



// WEBPACK FOOTER //
// ./src/config/constants.js